import React from 'react';
import styled from 'styled-components';

interface Props {
    rotate?: number
}

const BackIcon = ({rotate}: Props) => {
    return (
        <Wrapper rotate={rotate}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
            >
                <g fill="none" fillRule="evenodd">
                    <g>
                        <g>
                            <g>
                                <g>
                                    <g>
                                        <path
                                            d="M0 0L24 0 24 24 0 24z"
                                            transform="translate(-24 -120) translate(0 96) translate(24 24)"
                                        />
                                        <path
                                            fill="#21272E"
                                            d="M19 11H7.83l4.88-4.88c.39-.39.39-1.03 0-1.42-.39-.39-1.02-.39-1.41 0l-6.59 6.59c-.39.39-.39 1.02 0 1.41l6.59 6.59c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L7.83 13H19c.55 0 1-.45 1-1s-.45-1-1-1z"
                                            transform="translate(-24 -120) translate(0 96) translate(24 24)"
                                        />
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </Wrapper>

    );
}
const Wrapper = styled.div<{ rotate?: number }>`
    transform: rotate(${({rotate}) => rotate ? rotate : 0}deg);
`;
export default BackIcon;
